import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataCompany } from '../interfaces/lip-data-company';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Data } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IpCompanyService {

  private api = environment.api;

 // private sharigInfoCompany = new BehaviorSubject<string>("url");
 // url$ = this.sharigInfoCompany.asObservable;

 // updateData(newData : string){
 //   this.sharigInfoCompany.next;
 // } 

  constructor(private http: HttpClient) {}

  
  getCompanyData(url: string): Observable<DataCompany> {
    
    const partes = url.split("//")[1].split("/")[0];
    const dominioPartes = partes.split(".");
    dominioPartes.pop();
    const dominioPrincipal = dominioPartes.join(".");
    
    url = dominioPrincipal;
  
    let params = new HttpParams().set('url', url)
    return this.http.get<DataCompany>(`${this.api}/invopay/enterprises/info`, {params});
  }
  
}
